export enum GlobalCxmRoutes {
  BASE = 'cxm'
}
